import React, { Component } from 'react';
import { Card, Avatar, message, Input, List, Breadcrumb } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import StepModal from '../../components/modals/StepModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Level extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {step_number: 1, profile_id: 1};
    this.state = {redirect: false, level: {name: '', status: true, steps: []}, profiles: [], filteredSteps: [], modalVisible: false, current: this.schema, handleSave: this.handleCreate};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getLevel = this.getLevel.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleDeleteStep = this.handleDeleteStep.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getLevel();
    this.getProfiles();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getLevel() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/levels/${id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({level: resp.data, filteredSteps: resp.data.steps});
    });
  }

  getProfiles() {
    axios.get(`${Configuration.apiServer}/api/v1/profiles`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({profiles: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/levels/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getLevel();
    });
  }

  handleSearch(event) {
    const steps = this.state.level.steps.filter(step => {
      return step.profile.names.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredSteps: steps});
  }

  handleOpenModal(kind, record) { 
    if(kind === 'new') {
      this.setState({modalVisible: true, current: this.schema, handleSave: this.handleCreate});
    } else {
      this.setState({modalVisible: true, current: record, handleSave: this.handleUpdate});
    }
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleCreate(record) {
    const id = this.props.match.params.id;
    record['level_id'] = id;
    
    axios.post(`${Configuration.apiServer}/api/v1/steps`, {step: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getLevel();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    }); 
  }

  handleUpdate(record) {
    axios.put(`${Configuration.apiServer}/api/v1/steps/${this.state.current.id}`, {step: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getLevel();
      this.setState({modalVisible: false});
      message.success('Registro actualizado');
    });
  }

  handleDeleteStep(id) {
    axios.delete(`${Configuration.apiServer}/api/v1/steps/${id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getLevel();
    });
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex flex-row flex-start">
            <Breadcrumb>
              <Breadcrumb.Item> <a href="/admin/levels">Niveles</a> </Breadcrumb.Item>
              <Breadcrumb.Item>{this.state.level.name}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <div style={{ width: '30%', padding: '0px 10px' }}>
              <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '100%' }} />

              <br/><br/>

              <Card
                style={{ width: '100%', margin: '0px' }}
              >
                <Meta
                  avatar={<Avatar icon="safety" />}
                  title={this.state.level.name}
                  description={<span className={`cursor text-${Configuration.getStatus(this.state.level.status).color}`} onClick={() => { this.handleStatus(this.state.level.id) }}>{Configuration.getStatus(this.state.level.status).text}</span>}
                />
              </Card>
            </div>

            <div style={{ width: '70%', padding: '0px 10px' }}>
              <List
                itemLayout="horizontal"
                dataSource={this.state.filteredSteps}
                renderItem={step => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                      title={<a href="https://ant.design">{step.profile.names}</a>}
                      description={`Paso #${step.step_number}`}
                    />
                    <button className="btn btn-danger btn-sm" onClick={() => { this.handleDeleteStep(step.id)} }>Borrar</button>
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>

        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />
        
        <StepModal visible={this.state.modalVisible} title={"Nuevo paso de autorización"} profiles={this.state.profiles} current={this.state.current} handleClose={this.handleCloseModal} handleSave={this.state.handleSave} />

      </div>
    );
  }
}

export default Level;



// WEBPACK FOOTER //
// ./src/pages/admin/Level.js